module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChat),
      expression: "showChat"
    }],
    staticClass: "chat-container"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('div', {
    staticClass: "chat-close"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/close.svg")
    },
    on: {
      "click": _vm.closeChatPanel
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    ref: "chat-content",
    staticClass: "chat-content"
  }, [(_vm.noMessages) ? _c('div', {
    staticClass: "chat-empty-state"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.noMessages) ? _c('div', {
    staticClass: "chat-messages"
  }, _vm._l((_vm.chatMessages), function(message, index) {
    return _c('message', {
      key: index,
      attrs: {
        "message": message
      }
    })
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "chat-footer"
  }, [_c('div', {
    class: ("footer-message-container " + (_vm.messageTextareaFocus ? 'footer-message-container-focus' : ''))
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "chat-message",
    staticClass: "message-textarea",
    attrs: {
      "maxlength": "10000",
      "rows": "1",
      "placeholder": "Send message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.sendMessage($event)
      },
      "keydown": function($event) {
        _vm.autoResize($event)
      },
      "focus": function($event) {
        _vm.messageTextareaFocus = true
      },
      "focusout": function($event) {
        _vm.messageTextareaFocus = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send-button",
    on: {
      "click": function($event) {
        _vm.sendMessage($event)
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-title"
  }, [_c('span', [_vm._v("Live chat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-empty-state-content"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/chat.svg")
    }
  }), _vm._v(" "), _c('span', [_vm._v("Chat won't be visible in live broadcast.")]), _vm._v(" "), _c('span', [_vm._v("Be the first to write something")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97896eb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatPanel.vue
// module id = 373
// module chunks = 1